import { jsxs as l, jsx as C } from "react/jsx-runtime";
const r = ({
  width: t,
  height: i,
  className: e
}) => /* @__PURE__ */ l(
  "svg",
  {
    className: e,
    fill: "none",
    height: i,
    viewBox: "0 0 12 12",
    width: t,
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ C(
        "path",
        {
          d: "M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l("g", { clipPath: "url(#clip0_2564_24862)", children: [
        /* @__PURE__ */ C(
          "path",
          {
            d: "M5.99463 9.86208C3.83466 9.86208 2.06885 8.10152 2.06885 5.94156C2.06885 3.76057 3.81364 2.00527 5.98937 2.00001C8.17036 1.99476 9.93092 3.75531 9.93092 5.9363C9.93092 8.10678 8.17036 9.86208 5.99463 9.86208ZM9.14786 5.9363C9.16363 4.22304 7.75518 2.79883 6.03141 2.78307C4.29713 2.76204 2.86767 4.16523 2.8519 5.90477C2.83614 7.63905 4.23933 9.06852 5.98412 9.08428C7.7184 9.10005 9.1321 7.69686 9.14786 5.94156V5.9363Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M6.39413 4.94839C6.39413 5.26372 6.39413 5.57379 6.39413 5.88911C6.39413 6.02575 6.34683 6.13611 6.25223 6.23597C5.86333 6.61961 5.47969 7.00851 5.09079 7.39741C4.92262 7.56558 4.68087 7.57084 4.52321 7.41317C4.36029 7.25551 4.3708 7.00851 4.53898 6.84034C4.87007 6.50925 5.20641 6.17816 5.5375 5.84707C5.59005 5.79451 5.61108 5.74196 5.61108 5.66838C5.61108 5.10606 5.61108 4.54373 5.61108 3.9814C5.61108 3.69761 5.86333 3.50842 6.1261 3.59776C6.28902 3.65031 6.39413 3.79221 6.39413 3.97615C6.39413 4.30198 6.39413 4.62782 6.39413 4.95365V4.94839Z",
            fill: "white"
          }
        )
      ] }),
      /* @__PURE__ */ C("defs", { children: /* @__PURE__ */ C("clipPath", { id: "clip0_2564_24862", children: /* @__PURE__ */ C(
        "rect",
        {
          fill: "white",
          height: "7.86207",
          transform: "translate(2.06885 2)",
          width: "7.86207"
        }
      ) }) })
    ]
  }
);
export {
  r as Content
};
